export default {
    methods:{
    	confirm_dlg(title){
	        return new Promise((resove,reject)=>{
	            let dlg_conf = {
	                title,
	                fields:[],
	                action :({close,self,type})=>{
	                    if(type=='cancel') return reject('cancel');
	                    self.close_dialog();
	                    return resove(type);
	                }
	            }
	            this.$store.commit('USER_INPUT_FIELDS',dlg_conf)
	        })
	    },
	    edit_sale_note_dlg(title){
	    	if (this.$store.getters.get_pay_info.pay_status > 0) {
		        this.msgpad_show("msgpad", "ERROR", '本单已经结算！', 'error');
		        return;
		    };
	        return new Promise((resove,reject)=>{
	            let dlg_conf = {
	                title,
	                fields:[{
	                        title       :'备注',
	                        placeholder :'备注',
	                        type        :"string",
	                        value       : this.order_note,
	                        name        :'note',
	                        err_msg     :[],
	                        rules       :[v => !!v|| "备注是必须的"]
	                    }],
	                action :({close,self,type,data})=>{
	                    if(type=='cancel') return reject('cancel');
	                    let ok = self.$refs.form.validate();
	                    if(!ok) return reject(false);
	                    self.close_dialog();
	                    return resove(data);
	                }
	            }
	            this.$store.commit('USER_INPUT_FIELDS',dlg_conf)
	        }).then(data=>{
	            debugger
	            this.$store.commit('PRODUCTS_EDIT_NOTE',data.note)
	        })
	    },
    }
  }




// WEBPACK FOOTER //
// ./src/mixin/g_sale.js